import { render, staticRenderFns } from "./ComponentsSettings.vue?vue&type=template&id=505c20f2&"
import script from "./ComponentsSettings.vue?vue&type=script&lang=js&"
export * from "./ComponentsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports